import { useNavigate } from "react-router-dom";
import { ArrowLeft, ShieldCheck, LogOut } from "lucide-react";
import { useAuth } from "@/lib/auth";

// Dedicated full-page admin shell — no user sidebar, no "New idea" button.
// Visually distinct ribbon + back-to-dashboard pill.
export default function AdminLayout({ children }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  return (
    <div className="min-h-screen" style={{ background: "var(--bg)", color: "var(--ink)" }}>
      {/* Brass ribbon header — admin-only signal */}
      <div
        className="sticky top-0 z-30 backdrop-blur-xl"
        style={{ background: "rgba(14,8,5,0.94)", borderBottom: "1px solid var(--seal)" }}
      >
        <div className="max-w-6xl mx-auto px-4 md:px-8 py-3 flex items-center justify-between gap-3 flex-wrap">
          <button
            onClick={() => navigate("/dashboard")}
            className="btn-secondary text-[11px] uppercase tracking-[0.18em]"
            data-testid="admin-back-to-dashboard"
          >
            <ArrowLeft size={12} /> Back to dashboard
          </button>

          <div className="flex items-center gap-2 px-3 py-1.5 rounded-full" style={{ background: "rgba(216,168,87,0.10)", border: "1px solid rgba(216,168,87,0.35)" }}>
            <ShieldCheck size={12} style={{ color: "var(--seal)" }} />
            <span className="text-[10px] uppercase tracking-[0.22em]" style={{ color: "var(--seal)" }}>
              Admin Console
            </span>
          </div>

          {user && (
            <div className="flex items-center gap-2.5 text-xs" style={{ color: "var(--ink-55)" }} data-testid="admin-header-user">
              {user.picture ? (
                <img src={user.picture} alt="" className="w-7 h-7 rounded-full" style={{ border: "1px solid var(--ink-22)" }} />
              ) : (
                <div className="w-7 h-7 rounded-full" style={{ background: "var(--surface-2)" }} />
              )}
              <span className="hidden sm:inline truncate max-w-[180px]">{user.email}</span>
              <button onClick={logout} title="Sign out" style={{ color: "var(--ink-55)" }} data-testid="admin-logout">
                <LogOut size={14} />
              </button>
            </div>
          )}
        </div>
      </div>

      <main className="max-w-6xl mx-auto px-4 md:px-8 py-8 md:py-12">
        {children}
      </main>
    </div>
  );
}
